export default {
  separateFileNameExt(data) {
    const re = /(.+?)(\.[^.]*$|$)/;
    return re.exec(data)[1];
  },
};
